export default __webpack_public_path__ + "static/media/closer-mystery.9adb9b52.txt";